// Import Vue
import Vue from 'vue';
import Vuex from 'vuex'

// Import Framework7
import Framework7 from 'framework7/framework7.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.scss';

// Import App Component
import App from '../components/app.vue';

import Toolbar from './toolbar'
import Navbar from './navbar'

import { formatDateTime } from './helpers'

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue)

Vue.use(Vuex)

Vue.component('toolbar', Toolbar)
Vue.component('navbar', Navbar)

Vue.filter('formatDateTime', value => {
  return formatDateTime(new Date(value))
})

// Init App
new Vue({
  el: '#app',
  render: (h) => h(App),

  // Register App Component
  components: {
    app: App
  },
});